module.exports = __webpack_public_path__ + "media/images/emblems/Nendaz-armoiries-3a3aa3c2b9cb6362a7e590f6c38894eb.svg";